import React, { useEffect, useState } from "react";
import { LiaMapMarkedAltSolid } from "react-icons/lia";

import GoogleMapModal from "./modal";
import ListingMiniMap from "./mini-map";

import "./styles.css";

const GoogleMap = ({ locationDetails, params, filters, paramFilters, summary, searchCriteria, setSearchCriteria, setErrors, handleSort, sortType }) => {
  const [isOpened, setIsOpned] = useState(false);

  const handleShowOnMapClick = () => {
    setIsOpned(true);
    // window.location.hash = "map_opened";
  };
  const closeGoogleMapModal = () => {
    setIsOpned(false);
    // window.location.hash = "map_closed";
  };

  // window.location.hash === "#map_opened"
  useEffect(() => {
    if (!locationDetails.latitude || !locationDetails.longitude) {
      return;
    }

    if (window.location.hash === "#map_opened") {
      setIsOpned(true);
    }
  }, [window.location.hash, locationDetails.latitude, locationDetails.longitude]);

  return (
    <div>
      <button className="show-on-map" onClick={handleShowOnMapClick}>
        <ListingMiniMap locationDetails={locationDetails} />
      </button>

      <button className="map-button" onClick={handleShowOnMapClick}>
        Map
        <LiaMapMarkedAltSolid className="map-icon" />
      </button>

      <section className="google-map-section">
        <GoogleMapModal
          handleSort={handleSort}
          closeGoogleMapModal={closeGoogleMapModal}
          paramFilters={paramFilters}
          searchCriteria={searchCriteria}
          setSearchCriteria={setSearchCriteria}
          setErrors={setErrors}
          show={isOpened}
          onHide={closeGoogleMapModal}
          locationDetails={locationDetails}
          params={params}
          filters={filters}
          summary={summary}
          sortType={sortType}
        />
      </section>
    </div>
  );
};

export default GoogleMap;
